export const trackAnalyticsEvent = (name, properties = {}) => {
  if (typeof window === 'undefined' || !window || !window.analytics || !window.analytics.user) {
    setTimeout(() => { trackAnalyticsEvent(name, properties); }, 1000);
    return;
  }
  if (window.analytics.user().id() === null) {
    // TODO Needs refactoring, see issue: https://github.com/policygenius/pg-gatsby/issues/1401
    window.analytics.identify(traits.uuid);
  }

  if (name === 'Viewed High Intent Content') {
    window.analytics.page(
      name,
      properties
    );
  } else {
    window.analytics.page(location.pathname);
    window.analytics.track(
      name,
      properties
    );
  }
};

export const trackViewedPage = (event, props) => {
  const analyticsTraits = {
    ...props,
    event,
    context_user_agent: window.navigator.userAgent,
    context_page_title: window.document.title,
    context_page_url: window.location.href,
    context_page_path: window.location.pathname,
  };
  trackAnalyticsEvent(event, analyticsTraits);
};

// viewed landing page events
export const trackLandingPage = (props) => {
  trackViewedPage('Viewed landing page', props);
};

export const trackScrollSpyClick = (properties) => {
  const combinedProperties = Object.assign({
    event: 'scrollspy_navigate',
  }, properties);

  trackAnalyticsEvent('Clicked scrollspy', combinedProperties);
};

// generic modal events
export const trackClosedModal = (properties) => {
  trackAnalyticsEvent('Closed modal', properties);
};

export const trackViewedModal = (properties) => {
  trackAnalyticsEvent('Viewed modal', properties);
};

export const trackClickedLink = (properties) => {
  trackAnalyticsEvent('Clicked link', properties);
};

export const trackHighIntentPage = (properties) => {
  trackAnalyticsEvent('Viewed High Intent Content', properties);
};

// track cta click event
export const trackClickedCTA = (ctaId, performanceEvent, attributes) => {
  if (!(window && window.analytics)) return;

  window.analytics.track('Clicked CTA', {
    path: window.location.pathname,
    ctaId,
    ...attributes,
    context_page_path: window.location.pathname,
    context_page_referrer: document.referrer,
    context_page_title: window.document.title,
    context_page_url: window.location.href,
    context_user_agent: window.navigator.userAgent,
  });

  if (window.PGPerformance && performanceEvent) {
    window.PGPerformance.trackPerformanceEvent(performanceEvent);
  }
};



// WEBPACK FOOTER //
// ../src/utils/analytics/track.js